'use client';

import { usePathname } from 'next/navigation';
import SearchIcon from '../icons/search-icon';
import { MenuNavLink } from '../nav/menu-nav-link';
import { Button } from '../ui/button';
import { DEFAULT_MOBILE_SEARCH_LINK } from './default-config';

export function HeaderMobileSearch() {
  const pathname = usePathname();

  return (
    <Button
      asChild
      variant="ghost"
      size="icon"
      className="text-on-surface hover:bg-surface-variant size-11 shrink-0 rounded-[14px] bg-transparent xl:hidden"
    >
      <MenuNavLink
        item={DEFAULT_MOBILE_SEARCH_LINK}
        pathname={pathname}
        ariaLabel={DEFAULT_MOBILE_SEARCH_LINK.text}
        prefetch={false}
      >
        <SearchIcon className="size-6" size={24} aria-hidden />
      </MenuNavLink>
    </Button>
  );
}
